
import { CustomIcon } from './CustomIcon'

export const SolverIcon = () => (
  <CustomIcon
    iconCode="solver"
    width={18}
    height={18}
    title="Solver-related field"
    alt="Solver-related field"
  />
)
